import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { ScrollerSectionType01Component } from "../../../../modules/client/scroller-section/scroller_section-type01/scroller_section-type01.component";
import { BannerSectionType01Component } from "../../../../modules/client/banner-section/banner_section-type01/banner_section-type01.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChangeGameType01Component } from "../../../../modules/client/change-game/change-game-type01/change-game-type01.component";

@Component({
  selector: 'app-howzit',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink, ScrollerSectionType01Component, BannerSectionType01Component, MatIconModule, MatTooltipModule, ChangeGameType01Component],
  templateUrl: './howzit.component.html',
  styleUrl: './howzit.component.scss'
})
export class HowzitComponent implements OnInit {

  public view: any = {
    title: 'Our Solutions',
    page: {}
  }

  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef, private route: ActivatedRoute){

  }

  ngOnInit(): void {
    this.view.features = [];
    this.view.features.push({icon:"mat_solid:airplanemode_active", title:"Flights", text:"We revolutionize air travel with tailored itineraries and exclusive deals, ensuring convenience and unbeatable prices."});
    this.view.features.push({icon:"mat_solid:directions_boat_filled", title:"Cruises", text:"Elevating the cruise experience with personalized voyage planning, exclusive onboard perks, and hassle-free bookings."});
    this.view.features.push({icon:"mat_outline:car_rental", title:"Car Rental", text:"Changing the car rental game by offering seamless booking, flexible options, and premium service at competitive rates."});
    this.view.features.push({icon:"heroicons_outline:presentation-chart-line", title:"Marketing", text:"Redefining travel marketing with data-driven strategies that target the right audience and enhance customer engagement."});
    this.view.features.push({icon:"feather:monitor", title:"Technology", text:"Leveraging cutting-edge technology to streamline bookings, provide real-time updates, and offer an effortless travel experience."});
    this.view.features.push({icon:"mat_outline:airport_shuttle", title:"Transfers", text:"Innovating ground transfers with fast, reliable, and luxurious transportation solutions for a smooth journey from start to finish."});
  }
}
